module.exports = __webpack_public_path__ + "static/media/03_wakatukid13120d2d26dfd77ef24cbf0c3ffd710.webp";